import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export const FOUNDER_EMAIL = 'info@defences.ai';

export default function FounderRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#020202] flex items-center justify-center" data-testid="founder-loading">
        <div className="w-8 h-8 border-2 border-[#FF7A3D] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user || (user.email || '').toLowerCase() !== FOUNDER_EMAIL) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
